import SSBgImageHeadline from "@core-components/backgroundImage/components/BgImageHeadline";
import SSHeadLineHeader from "@core-components/title/components/SSHeadLineHeader";
import SSLoLGradientText from "@core-components/title/components/SSLoLGradientText";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Trans } from "react-i18next";
import avatar from "../../../assets/avatars/avatar-7.svg";
import AvatarWithText from "../../shared/avatar-text/AvatarWithText";
import SSBackgroundImage from "../../shared/backgroundImage/BackgroundImage";

export const SmurfsRankedHero = () => {
  const { t } = useAppTranslation("pages.ranked");

  return (
    <SSBackgroundImage>
      <SSBgImageHeadline
        header={<SSHeadLineHeader>{t("hero.header")}</SSHeadLineHeader>}
        subTitle={<AvatarWithText avatar={avatar} text={t("hero.subTitle")} />}
      >
        <Trans t={t} i18nKey={"hero.title"}>
          <SSWhiteText>NOS COMPTES</SSWhiteText>
          <SSLoLGradientText>CLASSÉS</SSLoLGradientText>
        </Trans>
      </SSBgImageHeadline>
    </SSBackgroundImage>
  );
};
